import React, { Component, Fragment } from "react";
import { getAllowedSwitches } from "../../../../AssetTypeConfig/Reports/SwitchinspectionReport";
import { ReportGeneratorUtils } from "../../utils/reportGeneratorUtils";
import { switchReportStyle } from "../../Timps/Switch/style/index";
import { themeService } from "../../../../theme/service/activeTheme.service";
import _ from "lodash";
import ReportTitleSection from "../../../../libraries/ReportGenerator/ReportTitleSection";
import { tick_char } from "../../../jobBriefing/JobBrieifingReport/special-char";
import { dataFormatters } from "../../../../utils/dataFormatters";
import ReportInfoSection from "../../../../libraries/ReportGenerator/ReportInfoSection";
import {
  SFRTA_SignalIncidentResponseRecord_MaterialSectionSchema,
  SFRTA_SignalIncidentResponseRecord_NotificationSectionSchema,
} from "./SFRTA_SignalIncidentResponseRecord_SectionsSchema";
import ReportTableSectionRenderer from "../../../../libraries/ReportGenerator";
import { ReportGroupingUtils } from "../../utils/reportGroupingUtils";
import { getTimeDiffBetweenTimes } from "../../../../utils/utils";
import { EqualContentsRow } from "../../../../libraries/ReportGenerator/EqualContentsRow";
import { KeyValBox } from "../../../../libraries/ReportGenerator/KeyValBox";

const SectionHeader = ({ title }) => {
  return (
    <div style={{ padding: "5px", textAlign: "left", fontSize: "20px", fontWeight: 600 }}>
      <span style={{ borderBottom: "2px solid" }}>{title}</span>
    </div>
  );
};

const SpecialKeyValComboBox = ({ rows, data }) => {
  const getRow = (row, i) => {
    const { columns, height } = row;
    return (
      <tr key={i} style={height ? { height: height } : {}}>
        {columns.map((property, i) => {
          const { title, titleColSpan, valId, valueColSpan } = property;
          return (
            <Fragment key={i}>
              <td colSpan={titleColSpan} style={{ textAlign: "center", fontWeight: "600", paddingLeft: "5px" }}>
                {`${title}:`}
              </td>
              <td colSpan={valueColSpan} className={"text-left pd-left-10px"}>
                {data[valId]}
              </td>
            </Fragment>
          );
        })}
      </tr>
    );
  };

  return (
    <div style={{ padding: "0px 35px 0 0", fontSize: "20px" }}>
      <table style={{ paddingLeft: "35px", width: "100%", paddingRight: "35px" }}>
        <tbody>
          {rows.map((row, i) => {
            return getRow(row, i);
          })}
        </tbody>
      </table>
    </div>
  );
};

const ReportView = ({ formSummary = {} }) => {
  formSummary.resTime = getTimeDiffBetweenTimes(formSummary.date1, formSummary.atime);
  formSummary.totTime = getTimeDiffBetweenTimes(formSummary.date1, formSummary.timerep);

  return (
    <div
      style={{
        width: "100%",
        overflowX: "auto",
        WebkitOverflowScrolling: "touch",
      }}
    >
      <div
        className="mainContent table-report last-page-break-print"
        style={{
          ...themeService(switchReportStyle.mainStyle),
          minWidth: "1100px",
          fontSize: "clamp(14px, 1vw, 20px)",
        }}
      >
        <ReportTitleSection title={`SIGNAL INCIDENT RESPONSE RECORD`} displayRevisedAreaText={"Revised: 3/21/17 (B)"} />

        <span className="spacer"></span>

        <EqualContentsRow>
          <KeyValBox title={"RESPONDER"} data={formSummary} id={"resp"} style={{ flexGrow: 2 }} />
          <KeyValBox title={"SIG/XNG"} data={formSummary} id={"sng"} />
        </EqualContentsRow>

        <EqualContentsRow>
          <KeyValBox title={"REPORTED BY"} data={formSummary} id={"repby"} />
          <KeyValBox title={"DATE"} data={formSummary} id={"date"} />
          <KeyValBox title={"TIME"} data={formSummary} id={"date1"} />
        </EqualContentsRow>

        <EqualContentsRow>
          <KeyValBox title={"LOCATION"} data={formSummary} id={"loca"} />
          <KeyValBox title={"ASSET"} data={formSummary} id={"ast"} />
          <KeyValBox title={"MP"} data={formSummary} id={"mpost"} />
        </EqualContentsRow>

        <span className="spacer"></span>

        <SpecialKeyValComboBox
          data={formSummary}
          rows={[
            { columns: [{ title: "REPORTED", valId: "repor", titleColSpan: 3, valueColSpan: 7 }] },
            { height: "100px", columns: [{ title: "DESCRIPTION", valId: "desc", titleColSpan: 3, valueColSpan: 17 }] },
          ]}
        />

        <EqualContentsRow>
          <KeyValBox title={"TIME OF ARRIVAL"} data={formSummary} id={"atime"} style={{ flexGrow: 2 }} />
          <KeyValBox
            title={"RESPONSE TIME"}
            data={formSummary}
            id={"resTime"}
            valBackground={"lightgray"}
            valColor={formSummary.resTime === "ERR!" ? "red" : null}
          />
        </EqualContentsRow>
        <SectionHeader title={"NOTIFICATIONS"} />
        <div style={{ padding: "0px 35px 0px 0px" }}>
          <table className="table-bordered" style={{ width: "100%" }}>
            <ReportTableSectionRenderer
              section={SFRTA_SignalIncidentResponseRecord_NotificationSectionSchema}
              rowsData={formSummary.bloc}
            />
          </table>
        </div>
        <SectionHeader title={"UPDATES"} />
        <SpecialKeyValComboBox
          data={formSummary}
          rows={[
            {
              columns: [
                { title: "TIME", valId: "time2", titleColSpan: 3, valueColSpan: 7 },
                { title: "BY", valId: "by", titleColSpan: 3, valueColSpan: 7 },
              ],
            },
            { height: "100px", columns: [{ title: "DESCRIPTION", valId: "desc1", titleColSpan: 3, valueColSpan: 17 }] },
          ]}
        />
        <SpecialKeyValComboBox
          data={formSummary}
          rows={[
            {
              columns: [
                { title: "TIME CLEARED", valId: "timeclr", titleColSpan: 3, valueColSpan: 7 },
                { title: "BY", valId: "by1", titleColSpan: 3, valueColSpan: 7 },
              ],
            },
            { height: "100px", columns: [{ title: "DESCRIPTION", valId: "desc2", titleColSpan: 3, valueColSpan: 17 }] },
          ]}
        />
        <SpecialKeyValComboBox
          data={formSummary}
          rows={[
            {
              columns: [
                { title: "CAUSE", valId: "cause", titleColSpan: 3, valueColSpan: 7 },
                { title: "CORRECTION", valId: "corre", titleColSpan: 3, valueColSpan: 7 },
              ],
            },
            { height: "100px", columns: [{ title: "DESCRIPTION", valId: "desc3", titleColSpan: 3, valueColSpan: 17, valueAlign: "left" }] },
          ]}
        />
        <EqualContentsRow>
          <KeyValBox title={"TIME REPAIRED"} data={formSummary} id={"timerep"} style={{ flexGrow: 2 }} />
          <KeyValBox
            title={"TOTAL TIME"}
            data={formSummary}
            id={"totTime"}
            valBackground={"lightgray"}
            valColor={formSummary.totTime === "ERR!" ? "red" : null}
          />
        </EqualContentsRow>
        <SectionHeader title={"MATERIALS"} />
        <div style={{ padding: "0px 35px 0px 0px" }}>
          <table className="table-bordered" style={{ width: "100%" }}>
            <ReportTableSectionRenderer section={SFRTA_SignalIncidentResponseRecord_MaterialSectionSchema} rowsData={formSummary.mater} />
          </table>
        </div>
      </div>
    </div>
  );
};

const SFRTA_SignalIncidentResponseRecord = (props) => {
  const { reportData, isPreview } = props;
  if (isPreview) {
    return <ReportView formSummary={{}} />;
  }

  let reportsByDateAndUser = ReportGroupingUtils.groupReportsByDateAndUser(reportData, true);
  let reportGroups = ReportGroupingUtils.filterReportsByTestCodes(reportsByDateAndUser, ["sfrtaSignalIncidentResponse"]);
  let reportsWithDecodedFormData = ReportGroupingUtils.decodeTestsInReportGroups(reportGroups);

  return reportsWithDecodedFormData.map((report, i) => {
    return report.decodedData.map((d, j) => <ReportView key={`${i}_${j}`} {...props} data={report} formSummary={d.summary} />);
  });
};

export default SFRTA_SignalIncidentResponseRecord;



// WEBPACK FOOTER //
// ./src/components/Reports/SFRTA/SignalIncidentResponseRecord/index.jsx